import { useState } from 'react'
import { lumi } from '@/lib/lumi'

export interface WorkLink {
  _id: string
  companyUserId: string
  companyName?: string
  collaboratorUserId: string
  collaboratorName?: string
  collaboratorEmail?: string
  position?: string
  area?: string
  status: 'pendiente' | 'aceptada' | 'rechazada' | 'finalizada'
  requestedBy?: 'empresa' | 'colaborador'
  startDate?: string
  endDate?: string
  creator?: string
  createdAt: string
  updatedAt: string
}

export function useLinks() {
  const [links, setLinks] = useState<WorkLink[]>([])
  const [loading, setLoading] = useState(false)

  const fetchByCompany = async (companyUserId: string) => {
    setLoading(true)
    try {
      const { list } = await lumi.entities.links.list({
        filter: { companyUserId },
        sort: { createdAt: -1 },
      })
      setLinks(list as WorkLink[])
    } catch (e) {
      console.error('Error al cargar vinculaciones (empresa):', e)
    } finally {
      setLoading(false)
    }
  }

  const fetchByCollaborator = async (collaboratorUserId: string) => {
    setLoading(true)
    try {
      const { list } = await lumi.entities.links.list({
        filter: { collaboratorUserId },
        sort: { createdAt: -1 },
      })
      setLinks(list as WorkLink[])
    } catch (e) {
      console.error('Error al cargar vinculaciones (colaborador):', e)
    } finally {
      setLoading(false)
    }
  }

  const createLink = async (data: Partial<WorkLink>) => {
    const now = new Date().toISOString()
    return lumi.entities.links.create({
      ...data,
      status: data.status || 'pendiente',
      creator: data.creator,
      createdAt: now,
      updatedAt: now,
    })
  }

  const updateLink = async (id: string, data: Partial<WorkLink>) => {
    return lumi.entities.links.update(id, {
      ...data,
      updatedAt: new Date().toISOString(),
    })
  }

  const deleteLink = async (id: string) => {
    return lumi.entities.links.delete(id)
  }

  return { links, loading, fetchByCompany, fetchByCollaborator, createLink, updateLink, deleteLink }
}
